import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Link,
  Text,
} from "@chakra-ui/react";
import imgOlive from "./../Banner/Alejandro-2.png";
import { motion } from "framer-motion";
import { useContext } from "react";
import { ThemeContext } from "./ThemeContext";


export default function About() {
  const theme = useContext(ThemeContext);

  return (
    <Box>
      <Flex
        id="about"
        className="section about"
        w={{ base: "90%", sm: "75%", md: "50%" }}
        p="10px"
        m="auto"
        borderTop="1.5px solid #00796B"
        flexDirection="column"
        justify="center"
        align="center"
        textAlign="center"
      >
        <Flex mt="55px" w={{ base: "100%", sm: "70%", md: "80%", lg: "50%" }}>
          <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
            <Image
              _hover={{
                boxShadow:
                  "rgba(218, 165, 32, 0.4) 0px 5px, rgba(218, 165, 32, 0.3) 0px 10px, rgba(218, 165, 32, 0.2) 0px 15px, rgba(218, 165, 32, 0.1) 0px 20px, rgba(218, 165, 32, 0.05) 0px 25px",
              }}
              className="home-img"
              style={{
                borderRadius: "50% 50% 50% 50% / 75% 75% 25% 25%",
                width: "80%",
              }}
              m="auto"
              src={imgOlive}
            />
          </motion.div>
        </Flex>
        <Heading color="#00796B" mt="25px">
          About Me
        </Heading>
        <Box mt="5px">
          <Text
            id="user-detail-intro"
            letterSpacing="1px"
            color={theme.theme.dText}
          >
            Hello! I'm a seasoned web developer with expertise in both frontend and backend development. 
            I have a strong background in creating user-friendly and visually appealing websites and applications. 
            With over 10 years of experience in web and game development, I have honed my skills to deliver top-notch solutions.
            As a chatGPT and OpenAI developer, I specialize in building interactive and engaging conversational interfaces. 
            I leverage cutting-edge technologies to create chatbots and virtual assistants that provide seamless user experiences.
            Additionally, I have a solid foundation in blockchain development. I am well-versed in blockchain technologies and have hands-on experience in creating decentralized applications (DApps) and smart contracts. 
            My expertise in blockchain allows me to develop secure and transparent solutions for various industries.
            Throughout my career, I have demonstrated my ability to combine technical expertise with a user-centered approach. 
            I am passionate about creating intuitive and user-friendly interfaces that enhance the overall user experience. 
            I believe in staying up-to-date with the latest industry trends and continuously expanding my knowledge to deliver innovative solutions.
            If you are looking for a skilled web developer with a strong technical background and a keen eye for design, I would be thrilled to collaborate with you. 
            Let's work together to bring your ideas to life and create exceptional digital experiences.
          </Text>
        </Box>
      </Flex>
    </Box>
  );
}
